export const fareharborModalStyles = {
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  mainText: { fontSize: "15px", fontWeight: "400" },

  subText: { fontSize: "13px", fontWeight: "400" },

  subBoldText: { fontSize: "13px", fontWeight: "600" },

  bodyContainer: {
    display: "flex",
    flexDirection: "row",
    gap: 1,
    marginTop: 1,
    alignItems: "flex-start",
  },
  buttonContainer: { display: "flex", marginY: 2, justifyContent: "center" },
  actionBtn: {
    width: "80%",
  },
  mv10: { marginY: "10px" },
};
